var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEmployerLiability = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.7,36.2c3,0,5.4-3,5.4-6.6c0-3.7-0.8-6.6-5.4-6.6s-5.4,3-5.4,6.6C32.3,33.2,34.7,36.2,37.7,36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4,46.3C27.4,46.1,27.4,46.2,27.4,46.3L27.4,46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,46.5C48,46.4,48,46,48,46.5L48,46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,46c-0.1-6.4-0.9-8.2-7.3-9.3c0,0-0.9,1.1-3,1.1s-3-1.1-3-1.1c-6.3,1.1-7.2,2.9-7.3,9.1c0,0.5,0,0.5,0,0.5c0,0.1,0,0.3,0,0.7c0,0,1.5,3.1,10.3,3.1c8.8,0,10.3-3.1,10.3-3.1c0-0.2,0-0.4,0-0.5C48,46.5,48,46.4,48,46z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.8,2.2V1.1v0V1.1V0.8h-0.1C25.6,0.3,25.2,0,24.7,0c-0.5,0-0.9,0.3-1.1,0.8h-0.1v1.4C12.3,2.7,3.1,11,2,21.5l0.5,0.1c0.6-2.4,2.7-4.1,5.2-4.1c2.6,0,4.8,1.9,5.3,4.3l0,0.2h0.6l0-0.2c0.5-2.5,2.7-4.4,5.3-4.4c1.9,0,3.6,1,4.6,2.5v20.6l0,0v2.7c0,1.3-1,2.3-2.1,2.3c-1.1,0-2.1-1-2.1-2.3c0-0.6-0.5-1.1-1.2-1.1c-0.5,0-1,0.4-1.1,0.9h0v0.3c0,2.5,1.9,4.6,4.4,4.6c2.5,0,4.4-2.1,4.4-4.6v-2.7l0,0V19.7c1-1.4,2.6-2.2,4.4-2.2c2.6,0,4.8,1.9,5.3,4.3l0,0.2h0.6l0-0.2c0.5-2.5,2.7-4.4,5.3-4.4c2.5,0,4.5,1.6,5.2,3.9l0.5-0.1C45.9,10.9,36.9,2.8,25.8,2.2z"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmployerLiability, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/employer-liability.06610abb.svg";
export { ForwardRef as ReactComponent };